import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
export const TaskNode = memo(({ data, selected }) => {
    const nodeData = data;
    const metadata = nodeData.metadata;
    return (_jsxs("div", { className: `flow-node-task ${selected ? "selected" : ""}`, style: {
            padding: "8px 12px",
            border: `1px solid ${selected ? "var(--flow-node-text, #000)" : "var(--flow-node-border, #e5e5e5)"}`,
            borderRadius: "4px",
            background: "var(--flow-node-bg, #fff)",
            minWidth: "140px",
            fontSize: "14px",
        }, children: [_jsx(Handle, { type: "target", position: Position.Top, style: { background: "var(--flow-node-border, #e5e5e5)" } }), _jsxs("div", { children: [_jsx("div", { style: {
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "var(--flow-node-text, #000)",
                            marginBottom: "6px",
                        }, children: metadata.title }), _jsxs("div", { style: {
                            fontSize: "11px",
                            color: "var(--flow-node-text-secondary, #444)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flexWrap: "wrap",
                        }, children: [_jsx("span", { style: {
                                    padding: "1px 5px",
                                    borderRadius: "3px",
                                    border: "1px solid var(--flow-node-border, #e5e5e5)",
                                    fontSize: "10px",
                                    fontWeight: 500,
                                }, children: metadata.status }), _jsx("span", { style: {
                                    padding: "1px 5px",
                                    borderRadius: "3px",
                                    background: getPriorityColor(metadata.priority),
                                    color: "#fff",
                                    fontSize: "10px",
                                    fontWeight: 500,
                                }, children: metadata.priority })] })] }), _jsx(Handle, { type: "source", position: Position.Bottom, style: { background: "var(--flow-node-border, #e5e5e5)" } })] }));
});
TaskNode.displayName = "TaskNode";
// Helper function to get priority color
function getPriorityColor(priority) {
    const p = priority.toLowerCase();
    if (p === "high" || p === "urgent")
        return "#000";
    if (p === "medium")
        return "#666";
    return "#999";
}
